var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#D2F34C",
    stroke: "#D2F34C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M47.1056 23H33.696C28.832 23 26 25.848 26 30.728V47.256C26 52.216 28.832 55 33.696 55H47.1056C52.048 55 54.8 52.216 54.8 47.256V30.728C54.8 25.848 52.048 23 47.1056 23Z",
    fill: "#244034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1283 44.9846H46.6723C47.3107 45.0486 47.7923 45.5925 47.7923 46.2485C47.7923 46.8869 47.3107 47.4326 46.6723 47.4965H34.1283C33.6483 47.5606 33.1843 47.3205 32.9283 46.9205C32.6723 46.5045 32.6723 45.9765 32.9283 45.5765C33.1843 45.1605 33.6483 44.9366 34.1283 44.9846ZM46.6723 37.687C47.3603 37.687 47.9203 38.2486 47.9203 38.9366C47.9203 39.6246 47.3603 40.1846 46.6723 40.1846H34.1283C33.4387 40.1846 32.8803 39.6246 32.8803 38.9366C32.8803 38.2486 33.4387 37.687 34.1283 37.687H46.6723ZM38.9107 30.4406C39.6003 30.4406 40.1603 31.0006 40.1603 31.687C40.1603 32.3926 39.6003 32.9526 38.9107 32.9526H34.1283C33.4387 32.9526 32.8803 32.3926 32.8803 31.7046C32.8803 31.0166 33.4387 30.4566 34.1283 30.4566V30.4406H38.9107Z",
    fill: "#244034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.5437fd2d48024207bd5da6fa53fb825d.svg";
export { ForwardRef as ReactComponent };